/**
 * @author PengWen
 * @description 岗位兼职信息管理页面配置
 * @Date 2022/11/28
 */
 import React from 'react';
 import {connect} from 'dva';
 import {component_tool, framework_tool, utils_tool} from '@/tool'
 import {Form, message, Popconfirm, Spin, Upload} from "antd";
 import { WizTableForm } from '@/containers/common';
 import RequirementPositionOrderForm from './requirementPositionOrderForm';
 let {WizContainer, modelUtils} = framework_tool;
 let {WizCard, WizSelect, WizSwitch, WizForm, WizSpin, WizModal, WizButton, WizIcon, WizDropdown, WizMenu, WizTable, WizRadio, WizDatePicker, WizTooltip } = component_tool;
 let Item = Form.Item;
 let Option = WizSelect.Option;
 let {Session} = utils_tool;
 
 class RequirementPositionOrderDetail extends WizContainer {
 
   componentName = 'RequirementPositionOrderDetail';
 
   constructor(props) {
     super(props);
     const {history} = props;
     let initialValue = {};
     if (history.location && history.location.pathname === '/dealerNewPersonTrain/requirementPositionOrder/requirementPositionOrderDetailUpd') {
       if (history.location && history.location.record) {
         initialValue = history.location.record;
         Session.set('requirementPositionOrderRecord', initialValue)
       } else {
         initialValue = Session.get('requirementPositionOrderRecord') || {};
       }
     }
     this.state = {
       
     };
     this.initialValue = initialValue;
   }
 
   propsAndStateOnChange = {
     requirementPositionOrderAdd: this._requirementPositionOrderAddOver.bind(this),
     requirementPositionOrderUpd: this._requirementPositionOrderUpdOver.bind(this),
   };
 
   /**
    * 将查询到的新开业培训加载到记录中
    */
    _getRequirementInfoOver(nextProps, nextState) {
     let requirementInfo = nextProps.requirementInfo.data;
     const {id} = requirementInfo;
     if (nextProps.requirementInfo.code == 1 && id && id>0) {
       this.initialValue.requirementContents = requirementInfo.requirementContents;
     }else {
       this.initialValue.id = null;
     }
     return true;
   }
 
 
   /**
    * 
    */
   _requirementPositionOrderAddOver(nextProps, nextState) {
     if (nextProps.requirementPositionOrderAdd.code == 1) {
       wizNotice.success('保存成功');
       this.jumpPage('replace', '/dealerNewPersonTrain/requirementPositionOrder');
     } else {
       wizNotice.error('提交失败：' + nextProps.requirementPositionOrderAdd.msg);
     }
     return true;
   }
 
   _requirementPositionOrderUpdOver(nextProps, nextState) {
     if (nextProps.requirementPositionOrderUpd.code == 1) {
       wizNotice.success('保存成功');
       this.jumpPage('replace', '/dealerNewPersonTrain/requirementPositionOrder');
     } else {
       wizNotice.error('提交失败：' + nextProps.requirementPositionOrderUpd.msg);
     }
     return true;
   }
 
   /**
    * 过滤字段值为undefined&null的字段
    * @param fieldsValue
    */
   fitterFieldsValue(fieldsValue) {
     let fitterValues = fieldsValue;
     if(this.initialValue.id){
       fitterValues.id = this.initialValue.id;
     }
     return fitterValues;
   };
 
   /**
    * 保存/更新 
    * @param values
    * @private
    */
   _saveRequirementPositionOrder(values) {
     const {history} = this.props;
     let apiPath = "requirementPositionOrder/add";
     let payloadKey = "requirementPositionOrder@add";
     if (history.location && history.location.pathname === '/dealerNewPersonTrain/requirementPositionOrder/requirementPositionOrderDetailUpd') {
       apiPath = "requirementPositionOrder/update";
       payloadKey = "requirementPositionOrder@update";
     }
     let fitterValues = this.fitterFieldsValue(values);
     this.doAction({
       path: apiPath,
       payload: {
         key: payloadKey,
         apiParams: {
           ...fitterValues
         }
       }
     });
   };
 
   
 
   _render() {
        return (
          <>
            <WizCard>
            <WizSpin tip={"加载中"} spinning={this.props.requirementPositionOrderLoading }>
                        <RequirementPositionOrderForm key = {this.state.ruleId} submit={(v) => { this._saveRequirementPositionOrder(v) }} data={this.initialValue}/>
                    </WizSpin>
            </WizCard>
          </>
        );
      }
 }
 
 const mapStateToProps = (state, ownProps) => {
   const {requirementPositionOrder} = state;
   const requirementPositionOrderAdd = modelUtils.getModelEntity(requirementPositionOrder, "requirementPositionOrder@add");
   const requirementPositionOrderUpd = modelUtils.getModelEntity(requirementPositionOrder, "requirementPositionOrder@update");
   const load = modelUtils.getLoadingState(state, ['requirementPositionOrder']);
   return {
     requirementPositionOrderAdd: requirementPositionOrderAdd,
     requirementPositionOrderUpd: requirementPositionOrderUpd,
     ...load
   }
 };
 
 export default connect(mapStateToProps)(RequirementPositionOrderDetail);
 